// TODO: Move away from ComponentName: React.FC to ComponentName = (): JSX.Element => {}

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import './app.scss'; // Define here to not override component-level CSS

import AppProvider from './_libs/app/provider';
import BrandProvider from './_libs/brand/provider';
import DataProvider from './_libs/data/provider';
import MicrosoftProvider from './_libs/microsoft/provider';

import TestAzureStorage from './pages/TestAzureStorage';
import DebugViewer from './templates/pdf/DebugViewer';

// Intro pages
import Name from './pages/intro/Name';
import Brand from './pages/intro/Brand';
import ZipCode from './pages/intro/ZipCode';
import Radius from './pages/intro/Radius';

// Bulk Upload pages
import BulkUploadIndexPage from './pages/bulk_upload/Index';
import CampaignsPage from './pages/bulk_upload/Campaigns';
import ColorSelectorPage from './pages/bulk_upload/ColorSelector';
import LeadsPage from './pages/bulk_upload/Leads';
import UploadCsvPage from './pages/bulk_upload/UploadCsv';

// Microsoft Marketplace pages
import MicrosoftIndexPage from './pages/microsoft/MicrosoftIndexPage';
import OAuthPage from './pages/microsoft/OAuthPage';
import PublisherSubscriptionDetailPage from './pages/microsoft/PublisherSubscriptionDetail';
import PublisherSubscriptionsPage from './pages/microsoft/PublisherSubscriptions';

import SubscriberSubscriptionsPage from './pages/microsoft/SubscriberSubscriptions';
import SubscriberLandingPage from './pages/microsoft/SubscriberLandingPage';
import SubscriberSubscriptionDetailPage from './pages/microsoft/SubscriberSubscriptionDetail';

import DashboardPage from './pages/Dashboard';
import IndexPage from './pages/Index';
import ReportCardPage from './pages/ReportCard';
import SupportPage from './pages/Support';

import Viewer from './templates/pdf/Viewer';

// NTH: Transition between routes https://reactcommunity.org/react-transition-group/with-react-router

// interface RoutesType {
//   path: string;
//   element: JSX.Element;
//   nodeRef: React.RefObject<unknown>;
// }

// const routes: RoutesType[] = [
//   { path: '/', element: <IntroStart />, nodeRef: createRef() },
//   { path: '/organization', element: <IntroOrganizationName />, nodeRef: createRef() },
//   { path: '/zipcode', element: <IntroZipCode />, nodeRef: createRef() },
//   { path: '/radius', element: <IntroRadius />, nodeRef: createRef() },
//   { path: '/dashboard', element: <ZipCodePage radius={10} />, nodeRef: createRef() },
// ];

Sentry.init({
  dsn: 'https://3fa737e0f17f41c7ac40852ade6d16c0@o49701.ingest.sentry.io/4504769794080768',
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
});

const App = (): JSX.Element => {
  return (
    <AppProvider>
      <DataProvider>
        <BrandProvider>
          {/* Note: Should this exist around the entire app? */}
          <MicrosoftProvider> 
            <BrowserRouter>
              <Routes>
                <Route path="debug_azure_storage" element={<TestAzureStorage />} />
                <Route path="debug" element={<DebugViewer />} />
                <Route path="/">
                  <Route index element={<IndexPage />} />
                  <Route path=":secondaryBrand" element={<IndexPage />} />
                  <Route path="organization" element={<Name />} />
                  <Route path="zip" element={<ZipCode />} />
                  <Route path="radius" element={<Radius />} />
                  <Route path="dashboard">
                    <Route index element={<DashboardPage />} />
                    <Route path=":materialsId" element={<DashboardPage />} />
                  </Route>
                  <Route path="brand" element={<Brand />} />
                  <Route path="materials">
                    <Route index element={<Viewer />} />
                  </Route>
                  {/* <Route path="credits" element={<CreditsPage />} /> */}
                  <Route path="report_card" element={<ReportCardPage />} />
                </Route>
                <Route path="/microsoft">
                  {/* Microsoft Subscriber Pages */}
                  <Route path="oauth_redirect_subscriber" element={<OAuthPage type="subscriber" />} />
                  <Route path="subscriber">
                    <Route index element={<MicrosoftIndexPage type="subscriber" />} />
                    <Route path="landing_page" element={<SubscriberLandingPage />} />
                    <Route path="subscriptions" element={<SubscriberSubscriptionsPage />} />
                    <Route path="details/:subscriptionId" element={<SubscriberSubscriptionDetailPage />} />
                  </Route>
                  {/* Lightbeam Publisher Pages */}
                  <Route path="oauth_redirect_publisher" element={<OAuthPage type="publisher" />} />
                  <Route path="publisher">
                    <Route index element={<MicrosoftIndexPage type="publisher" />} />
                    <Route path="subscriptions" element={<PublisherSubscriptionsPage />} />
                    <Route path="details/:subscriptionId" element={<PublisherSubscriptionDetailPage />} />
                  </Route>
                  {/* Bulk Upload Pages for Subscribers and Publishers */}
                  <Route path="bulk_upload">
                    <Route index element={<BulkUploadIndexPage />} />
                    <Route path="upload" element={<UploadCsvPage />} />
                    <Route path="campaigns">
                      <Route index element={<CampaignsPage />} />
                      <Route path=":campaignId">
                        <Route index element={<LeadsPage />} />
                        <Route path="confirm" element={<ColorSelectorPage />} />
                      </Route>
                    </Route>
                  </Route>
                </Route>
                <Route path="support" element={<SupportPage />} />
                <Route path="*" element={<Navigate to="/" replace={true} />} />
              </Routes>
            </BrowserRouter>
          </MicrosoftProvider>
        </BrandProvider>
      </DataProvider>
    </AppProvider>
  );
};

export default App;
